import {
  IEarlyDriveData,
  IFullSeatLineTurn,
  ITurn,
  ITurnLite,
} from "@/domain/entities/lineInfo";

export default function useGetEarlyDriveWeekdays(
  turns: ITurn[] | IFullSeatLineTurn[] | ITurnLite[]
): IEarlyDriveData[][] {
  return turns.map((turn) => turn.earlyDriveInfos || []);
}
